import React from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HomeIcon from '@mui/icons-material/Home';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import StorefrontIcon from '@mui/icons-material/Storefront';
import MapIcon from '@mui/icons-material/Map';
import BusinessIcon from '@mui/icons-material/Business';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import ApartmentIcon from '@mui/icons-material/Apartment';
import FactoryIcon from '@mui/icons-material/Factory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FolderIcon from '@mui/icons-material/Folder';
import StarIcon from '@mui/icons-material/Star';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import ListIcon from '@mui/icons-material/List';

/** Stable icon keys for location views — must match backend whitelist. */
export type LocationViewIconKey =
  | 'filter_list'
  | 'location_on'
  | 'home'
  | 'warehouse'
  | 'storefront'
  | 'map'
  | 'business'
  | 'place'
  | 'public'
  | 'apartment'
  | 'factory'
  | 'local_shipping'
  | 'folder'
  | 'star'
  | 'bookmark'
  | 'check_circle'
  | 'warning'
  | 'list';

export const DEFAULT_LOCATION_VIEW_ICON: LocationViewIconKey = 'filter_list';

export const LOCATION_VIEW_ICON_KEYS: LocationViewIconKey[] = [
  'filter_list', 'location_on', 'home', 'warehouse', 'storefront', 'map', 'business',
  'place', 'public', 'apartment', 'factory', 'local_shipping', 'folder', 'star',
  'bookmark', 'check_circle', 'warning', 'list',
];

export const LOCATION_VIEW_ICON_DEFINITIONS: { key: LocationViewIconKey; label: string }[] = [
  { key: 'filter_list', label: 'Filter' },
  { key: 'location_on', label: 'Location' },
  { key: 'home', label: 'Home' },
  { key: 'warehouse', label: 'Warehouse' },
  { key: 'storefront', label: 'Store' },
  { key: 'map', label: 'Map' },
  { key: 'business', label: 'Business' },
  { key: 'place', label: 'Place' },
  { key: 'public', label: 'Region' },
  { key: 'apartment', label: 'Building' },
  { key: 'factory', label: 'Site' },
  { key: 'local_shipping', label: 'Depot' },
  { key: 'folder', label: 'Files' },
  { key: 'star', label: 'Star' },
  { key: 'bookmark', label: 'Bookmark' },
  { key: 'check_circle', label: 'Active' },
  { key: 'warning', label: 'Alert' },
  { key: 'list', label: 'List' },
];

const ICON_COMPONENTS: Record<LocationViewIconKey, React.ElementType> = {
  filter_list: FilterListIcon,
  location_on: LocationOnIcon,
  home: HomeIcon,
  warehouse: WarehouseIcon,
  storefront: StorefrontIcon,
  map: MapIcon,
  business: BusinessIcon,
  place: PlaceIcon,
  public: PublicIcon,
  apartment: ApartmentIcon,
  factory: FactoryIcon,
  local_shipping: LocalShippingIcon,
  folder: FolderIcon,
  star: StarIcon,
  bookmark: BookmarkIcon,
  check_circle: CheckCircleIcon,
  warning: WarningIcon,
  list: ListIcon,
};

export function resolveLocationViewIconKey(value: unknown): LocationViewIconKey {
  if (typeof value === 'string' && LOCATION_VIEW_ICON_KEYS.includes(value as LocationViewIconKey)) {
    return value as LocationViewIconKey;
  }
  return DEFAULT_LOCATION_VIEW_ICON;
}

export function renderLocationViewIcon(icon: unknown, fontSize: 'small' | 'medium' | 'inherit' = 'medium'): React.ReactNode {
  const key = resolveLocationViewIconKey(icon);
  const Icon = ICON_COMPONENTS[key];
  return React.createElement(Icon, { fontSize });
}
